module.exports = __webpack_public_path__ + "static/media/merchandising-guide.9d88d75c.png";